'use client'

import { useTranslation } from '../../hooks/useTranslation';

export default function HeroSection({ homeData }) {
  const { t } = useTranslation();

  const stats = [
    { label: t('count.premiumCars'), count: homeData?.count ? homeData?.count?.premium_cars + "+" :'50+', icon: 'cars' },
    { label: t('count.exclusive'), count: homeData?.count ? homeData?.count?.exclusive_brands + "+" :'10+', icon: 'brands' },
    { label: t('count.years'), count: homeData?.count ? homeData?.count?.experience + "+" :'5+', icon: 'exp' },
    { label: t('count.customers'), count: homeData?.count ? homeData?.count?.happy_customers + "+" :'100+', icon: 'cus' }
  ];

  // Call Click Handler
    const handleCallClick = () => {
        window.location.href = `/cars`;
    };

  return (
    <section className="relative text-white overflow-hidden min-h-[100vh]">
      {/* Background Image Container */}
      <div className="banner-wrapper" style={{zIndex: "-100", position: "relative", float:"right"}}>
        <img src="images/banner.png" alt="" className="bnr-img"/>
      </div>
      {/* Overlay (optional) */}
      <div className="absolute inset-0 z-0"></div>

      {/* Foreground Content */}
      <div className="container lg:mx-[120px] px-4 mt-24 max-w-7xl relative z-10">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12 min-h-[60vh]">

          {/* Left Side Content */}
          <div style={{position: "absolute", width: "fit-content"}} className="lg:w-1/2 lg:mt-[150px] mt-[100px] space-y-8">
            <h1 className="banner-title">{t('heroTitle')}</h1>
            <p className="text-lg text-gray-300 max-w-lg leading-relaxed">
              {t('heroDesc')}
            </p>
            <button onClick={handleCallClick} className="bg-[#006FFF] hover:bg-blue-700 text-white px-12 font-medium py-4 rounded-lg transition-all transform hover:scale-105 shadow-lg">
              {t('explore')}
            </button>
          </div>

          {/* Right Side Empty Space to Maintain Layout */}
          <div className="lg:w-1/2"></div>
        </div>
      </div>

      {/* Stats */}
      <div className="flex flex-wrap justify-center item-center lg:justify-center gap-12 lg:mt-[170px] mt-[100px]" style={{width: "100%"}}>
        {stats.map(({ label, count, icon }) => (
          <div key={label} className="flex items-center space-x-3 bg-[#515151A6] backdrop-blur-sm rounded-lg px-3 py-2.5">
            <div>
              <span className="font-bold text-xl text-white font-bold">{count}</span>
              <span className="text-gray-300 ml-2 text-sm">{label}</span>
            </div>
            <div className="text-blue-400">
              <img src={`/images/icons/${icon}.png`} alt={label} className="h-8 rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
